export default "__VITE_ASSET__764c2c27__"